import React from 'react';
import SimpleDialog from 'components/Dialog/SimpleDialog';
import PropTypes from 'prop-types'
import FormConditionList from 'components/forms/FormConditionList'

// condition format
// {
//   name: 'brand',
//   condition: 'is_not',
//   value: '68,69',
// }

const ConditionDialog = ({
  condition,
  onUpdateCondition,
  onClose,
  open,
  title,
}) => (
  <SimpleDialog onClose={onClose} open={open} hasSubmit={false} title={title}>
    <div style={{ height: 500, overflow: 'auto', width: '100%', margin: 'auto' }}>
      <b> Condition : </b>
      <FormConditionList
        value={condition}
        onChange={(val) => onUpdateCondition(val)}
      />
    </div>
  </SimpleDialog>);

ConditionDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
}

ConditionDialog.defaultProps = {
  onClose: () => {},
  open: false,
  title: '',
}

export default ConditionDialog



// WEBPACK FOOTER //
// ./src/components/Dialog/ConditionDialog.js